export const createAccountsResp = {
  result: true,
  message: "Operation in progress! You will be notified once completed",
  data: "43fa8a4d-4fe2-4d61-9f4b-3c81b635a3cc",
};
